import { Anchor, Badge, Card, Stack, Table, Text, Title } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';

import { unwrap } from '../api/client';
import { useOrg } from '../api/org';
import { listAgentSessions } from '../api/gen';

const colours: Record<string, string> = {
  active: 'blue',
  completed: 'green',
  error: 'red',
  max_iterations: 'orange',
};

export function SessionsPage() {
  const headers = useOrg();
  const { data, isLoading } = useQuery({
    queryKey: ['sessions'],
    queryFn: () => unwrap(listAgentSessions({ headers, query: { limit: 100 } })),
    refetchInterval: 5_000,
  });

  return (
    <Stack>
      <Title order={3}>Sessions</Title>
      <Text c="dimmed" size="sm">
        Every conversation, including the ones a schedule or a trigger opened —
        those carry the cause as their title.
      </Text>

      <Card withBorder p={0}>
        <Table striped highlightOnHover>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Session</Table.Th>
              <Table.Th>Status</Table.Th>
              <Table.Th>Steps</Table.Th>
              <Table.Th>Tokens</Table.Th>
              <Table.Th>Opened</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {isLoading && (
              <Table.Tr>
                <Table.Td colSpan={5}>Loading…</Table.Td>
              </Table.Tr>
            )}
            {data?.data.map((s) => (
              <Table.Tr key={s.id}>
                <Table.Td>
                  <Anchor component={Link} to={`/sessions/${s.id}`}>
                    {s.title || s.id.slice(0, 8)}
                  </Anchor>
                  <Text size="xs" c="dimmed">
                    {s.createdBy}
                  </Text>
                </Table.Td>
                <Table.Td>
                  <Badge variant="light" color={colours[s.status] ?? 'gray'}>
                    {s.status}
                  </Badge>
                </Table.Td>
                <Table.Td>{s.stepCount}</Table.Td>
                <Table.Td>
                  <Text size="sm">{s.promptTokens + s.completionTokens}</Text>
                </Table.Td>
                <Table.Td>
                  <Text size="sm">{new Date(s.createdAt).toLocaleString()}</Text>
                </Table.Td>
              </Table.Tr>
            ))}
            {data?.data.length === 0 && (
              <Table.Tr>
                <Table.Td colSpan={5}>
                  <Text c="dimmed">No sessions yet.</Text>
                </Table.Td>
              </Table.Tr>
            )}
          </Table.Tbody>
        </Table>
      </Card>
    </Stack>
  );
}
